export const reportConfigs = {
  projectsByStatus: {
    title: 'Projects by Status',
    subtitle: 'Distribution of projects across workflow statuses',
    root_entity: 'projects',
    columns: ['status.name', 'project.uid'],
    filters: [],
    sorts: [],
    per_page: 100,
  },
  recentTimecards: {
    title: 'Recent Timecards',
    subtitle: 'Hours by project and team member (last 30 days)',
    root_entity: 'timecards',
    columns: [
      'user.first_name',
      'user.last_name',
      'timecard.total_hours',
      'project.uid',
    ],
    filters: [
      {
        field: 'timecard.time_in',
        operator: '>=',
        value: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      },
    ],
    sorts: [{ field: 'project.uid', direction: 'asc' }],
    per_page: 100,
  },
  equipmentDeployments: {
    title: 'Equipment Deployments',
    subtitle: 'Active equipment deployed across projects',
    root_entity: 'equipment_rooms',
    columns: ['equipment.name', 'deployment.date_in', 'deployment.quantity'],
    filters: [],
    sorts: [],
    per_page: 100,
  },
  projectsOverTime: {
    title: 'Projects Over Time',
    subtitle: 'Project creation trend by month',
    root_entity: 'projects',
    columns: ['project.created_at', 'project.uid'],
    filters: [],
    sorts: [{ field: 'project.created_at', direction: 'asc' }],
    per_page: 100,
  },
  projectList: {
    title: 'Project List',
    subtitle: 'All projects for selection',
    root_entity: 'projects',
    columns: ['project.uid', 'project.alias', 'project.created_at'],
    filters: [],
    sorts: [{ field: 'project.created_at', direction: 'desc' }],
    per_page: 25,
  },
  projectAudits: {
    title: 'Job Timeline',
    subtitle: 'Chronological timeline of project events',
    root_entity: 'audits',
    columns: [
      'audit.event',
      'audit.created_at',
      'audit.auditable_type',
      'audit.old_values',
      'audit.new_values',
      'user.full_name',
    ],
    filters: [],
    sorts: [{ field: 'audit.created_at', direction: 'desc' }],
    per_page: 50,
  },
};
